import type React from 'react'
import { cn } from '@/utils'

interface FieldErrorProps {
  id: string
  /** Overrides the default under-input styling (e.g. the Spacing controls' own error row). */
  className?: string
  children: React.ReactNode
}

/** The inline validation message under a Type panel numeric input. */
export function FieldError({ id, className, children }: FieldErrorProps) {
  return (
    <span id={id} role="alert" className={cn('text-xs text-destructive mt-1', className)}>
      {children}
    </span>
  )
}
